import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home8',
  templateUrl: './home8.component.html',
  styleUrls: ['./home8.component.scss']
})
export class Home8Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home8-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home8-page');
  }
}
